import * as z from 'zod';

export const schema = z.object({
  title: z.string().min(1),
  message: z.string().trim(),
});

export type Values = z.infer<typeof schema>;
